import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginForm from '../components/LoginForm';
import { useAuth } from '../contexts/AuthContext';
import { isFramed } from '../services/authService';

// One-shot guard: if the Keycloak round-trip fails we must not bounce the
// browser back into an endless redirect. Cleared on a successful login.
const AUTO_SSO_KEY = 'intermal.sso.autoRedirected';

const LoginPage: React.FC = () => {
  const { isAuthenticated, isLoading, ssoEnabled, loginWithSso } = useAuth();
  const navigate = useNavigate();
  const redirectingRef = useRef(false);

  useEffect(() => {
    // Redirect to home if already authenticated
    if (isAuthenticated) {
      sessionStorage.removeItem(AUTO_SSO_KEY);
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  useEffect(() => {
    if (!ssoEnabled || isAuthenticated || isLoading || redirectingRef.current) return;
    // Inside the Comm WebUI iframe a top-level redirect to Keycloak is
    // refused by its X-Frame-Options, so leave the button to the user.
    if (isFramed()) return;
    if (sessionStorage.getItem(AUTO_SSO_KEY)) return;

    redirectingRef.current = true;
    sessionStorage.setItem(AUTO_SSO_KEY, '1');
    loginWithSso('/').catch(() => {
      // Fall through to the rendered SSO button, which surfaces the error.
      redirectingRef.current = false;
    });
  }, [ssoEnabled, isAuthenticated, isLoading, loginWithSso]);

  return (
    <div className="auth-page">
      <LoginForm />
    </div>
  );
};

export default LoginPage;
